import _ from 'lodash';
import { MESSAGE_TYPES } from '@linearb/linjs-common';
import NewReposMessage from './NewRepoMessage';
import UntrackedReposMessage from './UntrackedReposMessage';
import AutoDiscoveryMesage from './AutoDiscoveryMesage';
import ReposCapLimitMessage from './ReposCapLimitMessage';

export const MESSAGE_CONSTRUCTORS = {
  [MESSAGE_TYPES.NEW_REPOS]: NewReposMessage,
  [MESSAGE_TYPES.UNTRACKED_REPOS]: UntrackedReposMessage,
  [MESSAGE_TYPES.REPO_AUTO_DISCOVERY]: AutoDiscoveryMesage,
  [MESSAGE_TYPES.REACHED_LIMIT_REPOS]: ReposCapLimitMessage,
  DEFAULT: () => null
};

export const getMessageConstructor = type => {
  return _.get(MESSAGE_CONSTRUCTORS, type, MESSAGE_CONSTRUCTORS.DEFAULT);
};
